import { Button, Modal, Row, Steps, Upload, notification } from 'antd'
import './ModalUploadPom.style.less'
import { useState } from 'react'
import {
  CheckCircleFilled,
  CloseCircleFilled,
  CloudUploadOutlined,
  FileExcelOutlined,
} from '@ant-design/icons'
import { useMutation } from 'react-query'
import {
  downloadPomExcel,
  uploadPomExcel,
} from '@/screens/Order/Pages/Order.transform'
import { saveExcel } from '@/utils/filesaver'
import { isEmptyValue } from '@/utils/common'

interface Props {
  visible: boolean
  onClose: () => void
  data: any
  onSave: (data: any) => void
}

function ModalUploadPom(props: Props) {
  const [current, setcurrent] = useState(0)

  const [uploadResult, setuploadResult] = useState(true)
  const [file, setfile] = useState(null)

  const [erroMessage, seterroMessage] = useState('')

  const steps = [
    {
      title: 'Download Template',
    },
    {
      title: 'Upload File',
    },
    {
      title: 'Done',
    },
  ]

  const uploadMutation = useMutation(async () => {
    return await uploadPomExcel(file, props.data.attributes)
  })

  const onClickNext = async () => {
    if (current == 2) return
    if (current == 1) {
      if (isEmptyValue(file)) {
        notification.error({ message: 'No file Selected', duration: 3 })
        return
      }
      const data = await uploadMutation.mutateAsync()
      if (data?.data?.statusCode == 400) {
        seterroMessage(data?.data?.message)
        setuploadResult(false)
      } else {
        seterroMessage('')
        setuploadResult(true)
      }
    }
    setcurrent(current + 1)
  }

  const onPrevious = () => {
    if (current == 0) return
    setcurrent(current - 1)
  }

  const downloadMutation = useMutation(async () => {
    const body = {
      number: 'test',
      sizes: props.data.attributes,
    }
    const data = await downloadPomExcel(body)
    const blob = new Blob([data.data])
    saveExcel(blob)
    return data
  })

  return (
    <Modal
      open={props.visible}
      onCancel={props.onClose}
      width={640}
      footer={false}
      className="modal-step-upload-pom"
    >
      <div>
        <p>Import from Excel</p>
        <Steps current={current} items={steps} />
        <div className="step-content-container">
          {current == 0 ? (
            <>
              <p>
                Download the Excel template and fill in your data for each size
                selected in Product Info:{' '}
                {props.data.attributes.map((item, index) => {
                  return (
                    <strong style={{ fontWeight: 600 }} key={index}>
                      {item}
                      {index + 1 != props.data?.attributes?.length ? ', ' : ''}
                    </strong>
                  )
                })}
                .
              </p>
              <Button onClick={() => downloadMutation.mutate()}>
                <FileExcelOutlined />
                <p>Download Excel Template</p>
              </Button>
            </>
          ) : current == 1 ? (
            <>
              <p>Upload the Excel template with your data filled in.</p>
              <Upload.Dragger
                name="files"
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                action="/upload.do"
                maxCount={1}
                beforeUpload={(files) => {
                  setfile(files)
                  return false
                }}
                onRemove={() => setfile(null)}
              >
                <p className="ant-upload-drag-icon">
                  <CloudUploadOutlined />
                </p>
                <p className="ant-upload-text">
                  Click or drag file to this area to upload
                </p>
              </Upload.Dragger>
            </>
          ) : uploadResult ? (
            <>
              <Row align={'middle'} className="success-container">
                <CheckCircleFilled style={{ color: '#65BF73' }} />
                <p className="success-title">Success!</p>
              </Row>
              <p className="success-descrption">
                Your data was imported correctly. You can now save and review
                it.
              </p>
            </>
          ) : (
            <>
              <Row align={'middle'} className="success-container">
                <CloseCircleFilled style={{ color: '#C03261' }} />
                <p className="success-title">Oops!</p>
              </Row>
              {!isEmptyValue(erroMessage) ? (
                <p className="success-descrption">{erroMessage}</p>
              ) : (
                <p className="success-descrption">
                  An error has occurred. Please check your file and try again.
                </p>
              )}
            </>
          )}
        </div>
        <Row className="stepper-button">
          {current != 2 && current != 0 && (
            <Button
              size="large"
              className="prev-button"
              onClick={onPrevious}
              disabled={uploadMutation.isLoading}
            >
              Previous
            </Button>
          )}
          {current == 2 && !uploadResult && (
            <Button
              size="large"
              className="prev-button"
              onClick={props.onClose}
            >
              Cancel
            </Button>
          )}
          {current == 2 && uploadResult && (
            <Button
              size="large"
              type="primary"
              className="next-button"
              onClick={() => {
                props.onSave(uploadMutation.data?.data?.data)
                props.onClose()
              }}
            >
              Save
            </Button>
          )}
          {current != 2 && (
            <Button
              size="large"
              type="primary"
              className="next-button"
              onClick={onClickNext}
              disabled={uploadMutation.isLoading}
            >
              Next
            </Button>
          )}
          {!uploadResult && current == 2 && (
            <Button
              size="large"
              type="primary"
              className="next-button"
              onClick={() => {
                setfile(null)
                onPrevious()
              }}
            >
              Try Again
            </Button>
          )}
        </Row>
      </div>
    </Modal>
  )
}

export default ModalUploadPom
